const Global = {
    socketPort:6001,
    wsHost: 'test.bubble-in.com',
    hotjar: {
        prodID: "3848159",
        testID: "3859258"
    }
}
export default Global;
